import { formatSearchResultUrl } from '@lumapps/ask-ai/utils';
import { addLocationOriginToUrl } from '@lumapps/router';

import { UserFeedbackSearchResultsDetails } from '../types';

/** Format the given results to match what the analytics api expects. */
export const formatSearchResultsForFeedbackAnalytics = (
    results?: UserFeedbackSearchResultsDetails[],
): UserFeedbackSearchResultsDetails[] | undefined =>
    results?.map(({ title, url }) => ({
        title,
        url: addLocationOriginToUrl(formatSearchResultUrl(url)),
    }));
